import React from 'react';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import { TypographyProps } from 'src/app/atoms/Typography/Typography';
import HeadingAndSupportingText from '../HeadingAndSupportingText/HeadingAndSupportingText';
import IdealMemberInput, { IdealMemberInputProps } from '../IdealMemberInput/IdealMemberInput';

interface CallToActionCardVerticalProps {
  headline: TypographyProps;
  description?: TypographyProps;
  inputProps: IdealMemberInputProps;
}

const CallToActionCardVertical = ({
  headline,
  description,
  inputProps,
}: CallToActionCardVerticalProps): JSX.Element => (
  <Grid totalColumns={1}>
    <Stack
      borderRadius='radius-2xl'
      background='bg-primary-solid'
      padding={['spacing-9xl', 'spacing-7xl']}
      paddingSm={['spacing-5xl', 'spacing-3xl']}
      justify='center'
      align='center'
    >
      <Stack
        direction='column'
        gap='spacing-4xl'
        justify='center'
        align='center'
        maxWidth='width-xl'
      >
        <HeadingAndSupportingText
          heading={{
            color: 'text-white',
            textAlign: 'center',
            ...headline,
          }}
          supportingText={{
            color: 'text-tertiary-on-brand',
            textAlign: 'center',
            ...description,
          }}
          gap='spacing-2xl'
          gapSm='spacing-xl'
        />
        <Grid maxWidth='width-lg'>
          <IdealMemberInput
            hasTerms={true}
            {...inputProps}
          />
        </Grid>
      </Stack>
    </Stack>
  </Grid>
);

export default CallToActionCardVertical;
